<template>
    <div class="ui-select__wrapper" :title="tooltip">
        <div class="ui-select__icon"></div>
        <select class="ui-select" :value="value" @change="onChangeSelect">
            <option v-for="option in options" :key="option.id" :value="option.id">
                {{ option.name }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: "UiSelect",
    props: ["value", "options"],
    methods: {
        onChangeSelect ($event) {
            this.$emit('input', $event.currentTarget.value);
            this.$emit('change', $event);
        }
    },
    computed: {
        tooltip () {
            for (const option of this.options) {
                if (option.id == this.value) {
                    return option.name;
                }
            }
            return '';
        }
    }
}
</script>

<style scoped>
    .ui-select {
        position: relative;
        width: 100%;
        padding: 9px 31px 9px 14px;
        border-radius: 5px;
        border: 1px solid #9A9A9B;
        background: #FFF;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        color: #0A1729;
        font-weight: 400;
        font-size: 14px;
        font-style: normal;
        line-height: 100%;
        letter-spacing: 0.024px;
    }

    .ui-select__wrapper {
        position: relative;
        min-width: 200px;
    }

    .ui-select__icon {
        position: absolute;
        top: 32%;
        right: 7px;
        width: 12px;
        height: 12px;
        background-image: url(../../../public/images/arrow-down.svg);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 5;
        pointer-events: none;
    }
</style>